import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-08e91b32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Восстановление пароля", -1))
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "auth-form-components"
}
const _hoisted_5 = { class: "flex flex-col input-labeled" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "E-mail", -1))
const _hoisted_7 = {
  key: 0,
  class: "bad-msg"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "after-info"
}
const _hoisted_10 = { class: "forgot" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-account" }, "Есть аккаунт?", -1))
const _hoisted_12 = {
  key: 3,
  class: "after-info m-t-12"
}
const _hoisted_13 = { class: "forgot" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-account" }, "Не получили письмо?", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 4,
  class: "fl-senter m-t-5"
}

import { ref, watch, onMounted, computed } from "vue";
import { getSecondForm } from "@/services/utils/DateParser";
import { setItemWithExpiry } from "@/services/utils/LocalStorage";

import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { rootGetters } from "@/main";

import InputText from "primevue/inputtext";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordRecoveryForm',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const isProgress = ref(false);
const countdown = ref<number>(0);
const email = ref("");
const invalid = ref(false);
const isMailSended = ref(false);
const sendingEnabled = ref(true);

let timer = 0;

const startResendEmailTimer = () => {
  countdown.value = 30;
  timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(timer);
      localStorage.removeItem("sendingEnabled");
      sendingEnabled.value = true;
    }
  }, 1000);
};

onMounted(() => {
  if (localStorage.getItem("recoveryEmail") != null) {
    isMailSended.value = true;
    email.value = localStorage.getItem("recoveryEmail");
  }

  if (localStorage.getItem("sendingEnabled")) {
    startResendEmailTimer();
  }
});

watch(
  () => email.value,
  () => {
    invalid.value = false;
  },
  { immediate: true }
);

const sendMail = () => {
  isProgress.value = true;
  invalid.value = false;

  authStore
    .resetPassword(email.value)
    .then(() => {
      setItemWithExpiry("recoveryEmail", email.value, 60);
      setItemWithExpiry("sendingEnabled", "0", 60);
      isMailSended.value = true;
      sendingEnabled.value = false;
      startResendEmailTimer();
    })
    .catch((err) => {
      if (err.response && err.response.status == 404) {
        invalid.value = true;
      } else {
        rootGetters.toast.show(
          "error",
          "Произошла ошибка",
          `Обратитесь к администратору или проверьте соединение с интернетом.`
        );
      }
    })
    .finally(() => {
      isProgress.value = false;
    });
};

const resetAll = () => {
  localStorage.removeItem("recoveryEmail");
  localStorage.removeItem("sendingEnabled");
  router.push({ name: "login" });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!isMailSended.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Укажите email, к которому привязан ваш аккаунт, и нажмите кнопку \"Подтвердить\", чтобы инициировать отправку письма со ссылкой на восстановление пароля.")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Мы отправили вам письмо на указанную почту (" + _toDisplayString(email.value) + ") со ссылкой на восстановление пароля. ", 1)
          ], 64))
    ]),
    (!isMailSended.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(InputText), {
              id: "username",
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              "aria-describedby": "username-help",
              placeholder: "Введите e-mail или номер телефона",
              invalid: invalid.value
            }, null, 8, ["modelValue", "invalid"])
          ]),
          (invalid.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Мы не нашли учетную запись с этим адресом электронной почты. "))
            : _createCommentVNode("", true),
          _createVNode(_unref(Button), {
            label: "Отправить",
            class: "form-button",
            onClick: sendMail,
            disabled: isProgress.value || email.value.length == 0
          }, null, 8, ["disabled"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(Button), {
            label: "Вернуться на страницу логина",
            class: "form-button m-t-12",
            onClick: resetAll
          })
        ])),
    (!isMailSended.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_router_link, { to: { name: 'login' } }, {
              default: _withCtx(() => [
                _createTextVNode("Войти")
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            (countdown.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Вы сможете отправить его повторно через: " + _toDisplayString(countdown.value) + " " + _toDisplayString(_unref(getSecondForm)(countdown.value)) + ". ", 1))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "pointer",
                  onClick: sendMail
                }, " Нажмите, чтобы отправить его снова"))
          ])
        ])),
    (isProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_unref(ProgressSpinner), {
            "aria-label": "Loading",
            style: {"width":"30px","height":"30px"},
            strokeWidth: "2",
            fill: "var(--surface-ground)"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})